const translations = {
  en: {
    nav: { 
      home: 'Home', 
      services: 'Services', 
      portfolio: 'Portfolio', 
      knowledge: 'Knowledge Centre', 
      about: 'About',
      contact: 'Contact', 
      cta: 'Book a Technical Survey' 
    },
    hero: {
      overline: 'Technical Waterproofing • Insulation • Diagnostics',
      title: 'Imperguel',
      subtitle: 'Protecting Portuguese homes and commercial buildings through expert diagnostics, premium waterproofing systems and long-lasting insulation solutions.',
      cta_primary: 'Book a Technical Survey',
      cta_secondary: 'Explore Our Services',
      badge: 'Nationwide Technical Waterproofing Specialists',
    },
    services: {
      overline: 'Our Services',
      title: 'What We Do',
      subtitle: 'Six areas of specialist expertise, one commitment to lasting protection.',
      viewAll: 'View All Services',
      pillar1: {
        label: '01 — Waterproofing',
        title: 'Waterproofing Systems',
        description: 'Complete waterproofing solutions using premium membrane systems, liquid applications and advanced sealants.',
        features: ['Foundation protection', 'Terrace waterproofing', 'Below-grade tanking', 'Expansion joints'],
      },
      pillar2: {
        label: '02 — Diagnostics',
        title: 'Technical Diagnostics',
        description: 'Precision diagnostics using thermal imaging, moisture analysis and drone technology.',
        features: ['Thermal camera analysis', 'Moisture mapping', 'Drone inspection', 'Technical reports'],
      },
      pillar3: {
        label: '03 — Roofing',
        title: 'Roof Waterproofing',
        description: 'Specialist roof waterproofing for flat and pitched roofs with premium membranes.',
        features: ['Flat roof systems', 'Pitched roof protection', 'Green roof waterproofing', 'Skylight sealing'],
      },
      pillar4: {
        label: '04 — Insulation',
        title: 'Thermal Insulation',
        description: 'Energy-efficient insulation systems that reduce heat loss and improve comfort.',
        features: ['ETICS facades', 'Internal insulation', 'Roof insulation', 'Thermal bridge correction'],
      },
      pillar5: {
        label: '05 — Commercial',
        title: 'Commercial Projects',
        description: 'Tailored solutions for commercial buildings, offices and mixed-use developments.',
        features: ['Office buildings', 'Retail spaces', 'Car parks', 'Podium decks'],
      },
      pillar6: {
        label: '06 — Industrial',
        title: 'Industrial Solutions',
        description: 'Heavy-duty waterproofing and insulation for factories, warehouses and infrastructure.',
        features: ['Factory roofing', 'Cold storage', 'Water treatment', 'Energy infrastructure'],
      },
    },
    about: {
      overline: 'About Imperguel',
      title: 'Precision-Led Protection',
      p1: 'Founded in Vila Nova de Famalicão, Imperguel delivers technical waterproofing, insulation and diagnostics across Portugal. Our team combines hands-on construction expertise with advanced diagnostic technology to solve complex building problems.',
      p2: 'We work with premium materials from Soprema and Asfaltex, applying rigorous methodology to every project. From initial survey to final inspection, every step follows a structured technical process.',
      p3: 'Diagnose precisely. Specify correctly. Protect permanently.',
      stats: { 
        projects: '500+', projects_label: 'Projects',
        satisfaction: '100%', satisfaction_label: 'Satisfaction',
        response: '24h', response_label: 'Response',
      },
    },
    portfolio: {
      overline: 'Portfolio',
      title: 'Selected Projects',
      subtitle: 'A selection of completed projects across residential, commercial and industrial sectors.',
      viewAll: 'View All Projects',
      categories: ['All', 'Villas', 'Apartments', 'Historic', 'Commercial', 'Industrial'],
    },
    contact: {
      overline: 'Get in Touch',
      title: 'Book a Technical Survey',
      subtitle: 'Describe your project. We respond within 24 hours.',
      cta_primary: 'Submit Survey Request',
      form: { 
        name: 'Full Name', 
        email: 'Email Address', 
        phone: 'Phone Number', 
        location: 'Property Location',
        location_placeholder: 'City, District or Address',
        service: 'Service Required',
        service_options: [
          { value: '', label: 'Select service' },
          { value: 'waterproofing', label: 'Waterproofing Systems' },
          { value: 'diagnostics', label: 'Technical Diagnostics' },
          { value: 'roof', label: 'Roof Waterproofing' },
          { value: 'insulation', label: 'Thermal Insulation' },
          { value: 'commercial', label: 'Commercial Project' },
          { value: 'industrial', label: 'Industrial Solution' },
          { value: 'other', label: 'Other' },
        ],
        message: 'Problem Description',
        submit: 'Submit Survey Request', 
        success: 'Technical survey request received. We will contact you within 24 hours.' 
      },
    },
    knowledge: {
      overline: 'Knowledge Centre',
      title: 'Technical Insights',
      subtitle: 'Expert guidance on waterproofing, insulation and building diagnostics.',
      readMore: 'Read Article',
      cta: 'Book a Technical Survey',
    },
    servicePage: { 
      problem: 'The Challenge', 
      solution: 'Our Approach', 
      materials: 'Materials & Technology', 
      scope: 'Scope of Work', 
      cta: 'Book a Technical Survey', 
      ctaSub: 'Get a professional assessment for your project.' 
    },
    footer: {
      tagline: 'Technical Waterproofing • Insulation • Diagnostics',
      country: 'Portugal',
      services_title: 'Services',
      company_title: 'Company',
      contact_title: 'Contact',
      quickLinks: 'Quick Links',
      legal: 'Legal',
      privacy: 'Privacy Policy',
      cookies: 'Cookies',
      terms: 'Terms & Conditions',
      rights: '© 2025 Imperguel. All rights reserved.',
    },
    whatsapp: { message: 'Hello, I would like to book a technical survey.%0A%0APlease indicate:%0A- Type of property%0A- Location%0A- Issue description' },
  },
  pt: {
    nav: { 
      home: 'Início', 
      services: 'Serviços', 
      portfolio: 'Portfólio', 
      knowledge: 'Centro de Conhecimento', 
      about: 'Sobre',
      contact: 'Contacto', 
      cta: 'Agendar Vistoria Técnica' 
    },
    hero: {
      overline: 'Impermeabilização Técnica • Isolamento • Diagnóstico',
      title: 'Imperguel',
      subtitle: 'Proteção de habitações e edifícios comerciais portugueses através de diagnóstico especializado, sistemas de impermeabilização premium e soluções de isolamento duradouras.',
      cta_primary: 'Agendar Vistoria Técnica',
      cta_secondary: 'Explorar Serviços',
      badge: 'Especialistas em Impermeabilização Técnica a Nível Nacional',
    },
    services: {
      overline: 'Os Nossos Serviços',
      title: 'O Que Fazemos',
      subtitle: 'Seis áreas de especialização, um compromisso com a proteção duradoura.',
      viewAll: 'Ver Todos os Serviços',
      pillar1: {
        label: '01 — Impermeabilização',
        title: 'Sistemas de Impermeabilização',
        description: 'Soluções completas de impermeabilização com membranas premium, aplicações líquidas e selantes avançados.',
        features: ['Proteção de fundações', 'Impermeabilização de terraços', 'Tanques subterrâneos', 'Juntas de dilatação'],
      },
      pillar2: {
        label: '02 — Diagnóstico',
        title: 'Diagnóstico Técnico',
        description: 'Diagnóstico de precisão com termografia, análise de humidades e tecnologia drone.',
        features: ['Análise com câmara térmica', 'Mapeamento de humidades', 'Inspeção por drone', 'Relatórios técnicos'],
      },
      pillar3: {
        label: '03 — Coberturas',
        title: 'Impermeabilização de Coberturas',
        description: 'Impermeabilização especializada para coberturas planas e inclinadas com membranas premium.',
        features: ['Coberturas planas', 'Coberturas inclinadas', 'Coberturas verdes', 'Selagem de claraboias'],
      },
      pillar4: {
        label: '04 — Isolamento',
        title: 'Isolamento Térmico',
        description: 'Sistemas de isolamento energeticamente eficientes que reduzem perdas de calor e melhoram o conforto.',
        features: ['Fachadas ETICS', 'Isolamento interior', 'Isolamento de coberturas', 'Correção de pontes térmicas'],
      },
      pillar5: {
        label: '05 — Comercial',
        title: 'Projetos Comerciais',
        description: 'Soluções à medida para edifícios comerciais, escritórios e empreendimentos de uso misto.',
        features: ['Edifícios de escritórios', 'Espaços comerciais', 'Parques de estacionamento', 'Decks sobre pódio'],
      },
      pillar6: {
        label: '06 — Industrial',
        title: 'Soluções Industriais',
        description: 'Impermeabilização e isolamento de alta resistência para fábricas, armazéns e infraestruturas.',
        features: ['Coberturas industriais', 'Câmaras frigoríficas', 'Tratamento de águas', 'Infraestruturas energéticas'],
      },
    },
    about: {
      overline: 'Sobre a Imperguel',
      title: 'Proteção Guiada pela Precisão',
      p1: 'Com sede em Vila Nova de Famalicão, a Imperguel oferece impermeabilização técnica, isolamento e diagnóstico em todo o Portugal. A nossa equipa combina experiência prática em construção com tecnologia de diagnóstico avançada para resolver problemas complexos de edifícios.',
      p2: 'Trabalhamos com materiais premium da Soprema e Asfaltex, aplicando uma metodologia rigorosa em cada projeto. Da vistoria inicial à inspeção final, cada etapa segue um processo técnico estruturado.',
      p3: 'Diagnosticar com precisão. Especificar corretamente. Proteger permanentemente.',
      stats: { 
        projects: '500+', projects_label: 'Projetos',
        satisfaction: '100%', satisfaction_label: 'Satisfação',
        response: '24h', response_label: 'Resposta',
      },
    },
    portfolio: {
      overline: 'Portfólio',
      title: 'Projetos Selecionados',
      subtitle: 'Uma seleção de projetos concluídos nos setores residencial, comercial e industrial.',
      viewAll: 'Ver Todos os Projetos',
      categories: ['Todos', 'Moradias', 'Apartamentos', 'Edifícios Históricos', 'Comercial', 'Industrial'],
    },
    contact: {
      overline: 'Fale Connosco',
      title: 'Agendar Vistoria Técnica',
      subtitle: 'Descreva o seu projeto. Respondemos em 24 horas.',
      cta_primary: 'Submeter Pedido de Vistoria',
      form: { 
        name: 'Nome Completo', 
        email: 'Email', 
        phone: 'Telefone', 
        location: 'Localização do Imóvel',
        location_placeholder: 'Cidade, Distrito ou Morada',
        service: 'Serviço Pretendido',
        service_options: [
          { value: '', label: 'Selecionar serviço' },
          { value: 'waterproofing', label: 'Sistemas de Impermeabilização' },
          { value: 'diagnostics', label: 'Diagnóstico Técnico' },
          { value: 'roof', label: 'Impermeabilização de Coberturas' },
          { value: 'insulation', label: 'Isolamento Térmico' },
          { value: 'commercial', label: 'Projeto Comercial' },
          { value: 'industrial', label: 'Solução Industrial' },
          { value: 'other', label: 'Outro' },
        ],
        message: 'Descrição do Problema',
        submit: 'Submeter Pedido de Vistoria', 
        success: 'Pedido de vistoria técnica recebido. Entraremos em contacto em 24 horas.' 
      },
    },
    knowledge: {
      overline: 'Centro de Conhecimento',
      title: 'Artigos Técnicos',
      subtitle: 'Orientação especializada sobre impermeabilização, isolamento e diagnóstico de edifícios.',
      readMore: 'Ler Artigo',
      cta: 'Agendar Vistoria Técnica',
    },
    servicePage: { 
      problem: 'O Desafio', 
      solution: 'A Nossa Abordagem', 
      materials: 'Materiais e Tecnologia', 
      scope: 'Âmbito de Intervenção', 
      cta: 'Agendar Vistoria Técnica', 
      ctaSub: 'Obtenha uma avaliação profissional para o seu projeto.' 
    },
    footer: {
      tagline: 'Impermeabilização Técnica • Isolamento • Diagnóstico',
      country: 'Portugal',
      services_title: 'Serviços',
      company_title: 'Empresa',
      contact_title: 'Contacto',
      quickLinks: 'Links Rápidos',
      legal: 'Legal',
      privacy: 'Política de Privacidade',
      cookies: 'Cookies',
      terms: 'Termos e Condições',
      rights: '© 2025 Imperguel. Todos os direitos reservados.',
    },
    whatsapp: { message: 'Olá, pretendo agendar uma vistoria técnica.%0APor favor indique:%0A- Tipo de imóvel%0A- Localização%0A- Descrição do problema' },
  },
};
export default translations;
